import React, { useState } from 'react';
import Grid from './Grid';
import SettingColumn from '../SettingColumn/SettingColumn';
import { Icons } from '../BootstrapComponents/BootstrapComponents';
import { useStoreState } from '../../../utils/utils';

export default function CustomizedGrid(props) {
  const {
    name,
    columns = [],
    additionalColumns = [],
    settingsFormatter = a => a,
  } = props;
  const [isOpen, setOpen] = useState(false);

  const settingsColumn = {
    dataField: 'setting',
    headerFormatter: () => <Icons width={24} height={24} customIcon icon="gear" className="button-icons" />,
    formatter: settingsFormatter,
    headerClassName: 'settings-column',
    dataClassName: 'settings-column',
    headerCallback: () => setOpen(true),
    // disablePosition: true,
    disableVisible: true,
  };

  const availableColumns = [...columns, settingsColumn].map((e, i) => ({ ...e, id: `${name}-column-${i}` }));
  const addColumns = additionalColumns.map((e, i) => ({ ...e, id: `${name}-column-${i + availableColumns.length}` }));
  const allColumns = [...availableColumns, ...addColumns];
  const initial = availableColumns.reduce((acc, cur) => { acc[cur.id] = true; return acc; }, {});
  const [visibleColumns, setVisibleColumns, resetVisible, saveVisible] = useStoreState(initial, name);
  const [columnsOrder, setColumnsOrder, resetOrder, saveOrder] = useStoreState(allColumns.map(c => c.id), `${name}-order`);
  return (
    <>
      <Grid {...props} columns={allColumns.filter(c => visibleColumns[c.id]).sort((a, b) => (columnsOrder.indexOf(a.id) - columnsOrder.indexOf(b.id)))} />
      <SettingColumn
        open={isOpen}
        lockOnPopup
        availableColumns={allColumns}
        setVisibleColumns={setVisibleColumns}
        visibleColumns={visibleColumns}
        setColumnsOrder={setColumnsOrder}
        columnsOrder={columnsOrder}
        resetVisible={resetVisible}
        resetOrder={resetOrder}
        saveVisible={saveVisible}
        saveOrder={saveOrder}
        addColumns={addColumns}
        onHide={() => { setOpen(false); }}
      />
    </>
  );
}
